/**
 * Number of applications by five underwriting/ re-underwriting, by place of Residence of Insured Person
 */

import {
	isHongKongResident,
	hasLoadings,
	hasExclusions
} from "@/modules/reports/schemas/utils/"

import get from "lodash.get"

export default payload => {
	const workSheetData = [...header, ...rows(payload)]
	const workSheetColumns = header[2].map(item => {
		return { wpx: 100 }
	})
	const workSheetMerges = [
		{
			s: { r: 0, c: 0 },
			e: { r: 0, c: 6 }
		},
		{
			s: { r: 1, c: 0 },
			e: { r: 2, c: 0 }
		},
		{
			s: { r: 1, c: 1 },
			e: { r: 1, c: 5 }
		},
		{
			s: { r: 1, c: 6 },
			e: { r: 1, c: 10 }
		}
	]
	return { workSheetData, workSheetColumns, workSheetMerges }
}

const header = [
	[
		"Template 02 - Number of applications by five underwriting/ re-underwriting, by place of Residence of Insured Person"
	],
	[
		"Place of Residence",
		"Standard Plan",
		"",
		"",
		"",
		"",
		"Flexi Plan",
		"",
		"",
		"",
		""
	],
	[
		"",
		"Standard Offer",
		"Offer with Premium Loading only",
		"Offer with CBE only",
		"Offer with Premium Loading and CBE",
		"Decline",
		"Standard Offer",
		"Offer with Premium Loading only",
		"Offer with CBE only",
		"Offer with Premium Loading and CBE",
		"Decline"
	]
]

const rows = payload => [
	[
		"Hong Kong",
		countStandardOffer(true, payload),
		countOfferWithLoadings(true, payload),
		countOfferWithExclusions(true, payload),
		countOfferWithLoadingsAndExclusions(true, payload),
		countDeclinedOffers(true, payload),
		0,
		0,
		0,
		0,
		0
	],
	[
		"Others",
		countStandardOffer(false, payload),
		countOfferWithLoadings(false, payload),
		countOfferWithExclusions(false, payload),
		countOfferWithLoadingsAndExclusions(false, payload),
		countDeclinedOffers(false, payload),
		0,
		0,
		0,
		0,
		0
	]
]

const countStandardOffer = (isPlaceOfResidence, payload) => {
	return payload.filter(policy => {
		let address = get(policy, "insured[0].addresses")
		let resident = isHongKongResident(address)
		if (policy.status === "QUOTING" && resident === isPlaceOfResidence) {
			return policy
		}
	}).length
}

const countOfferWithLoadings = (isPlaceOfResidence, payload) => {
	return payload.filter(policy => {
		let address = get(policy, "insured[0].addresses")
		let resident = isHongKongResident(address)
		let loadings = hasLoadings(policy)
		let exclusions = hasExclusions(policy)
		if (
			policy.status === "QUOTING" &&
			loadings === true &&
			exclusions === false &&
			resident === isPlaceOfResidence
		) {
			return policy
		}
	}).length
}

const countOfferWithExclusions = (isPlaceOfResidence, payload) => {
	return payload.filter(policy => {
		let address = get(policy, "insured[0].addresses")
		let resident = isHongKongResident(address)
		let exclusions = hasExclusions(policy)
		let loadings = hasLoadings(policy)
		if (
			policy.status === "QUOTING" &&
			exclusions === true &&
			loadings === false &&
			resident === isPlaceOfResidence
		) {
			return policy
		}
	}).length
}

const countOfferWithLoadingsAndExclusions = (isPlaceOfResidence, payload) => {
	return payload.filter(policy => {
		let address = get(policy, "insured[0].addresses")
		let resident = isHongKongResident(address)
		let loadings = hasLoadings(policy)
		let exclusions = hasExclusions(policy)
		if (
			policy.status === "QUOTING" &&
			loadings &&
			exclusions &&
			resident === isPlaceOfResidence
		) {
			return policy
		}
	}).length
}

const countDeclinedOffers = (isPlaceOfResidence, payload) => {
	return payload.filter(policy => {
		let address = get(policy, "insured[0].addresses")
		let resident = isHongKongResident(address)
		if (policy.status === "REJECTED" && resident === isPlaceOfResidence) {
			return policy
		}
	}).length
}
